import React from "react";
import { Colors } from "../../../../utils/colors";
import { TCText } from "../../../../components/TCText/TCText";

type props = {
  gridBgColor?: string;
  scoreValue?: string;
  borderBottomRightRadius?: number;
  borderBottomLeftRadius?: number;
  containerStyle?: React.CSSProperties;
};

export const ClutterGraphGrid: React.FC<props> = ({
  gridBgColor,
  scoreValue,
  borderBottomRightRadius,
  borderBottomLeftRadius,
  containerStyle,
}) => {
  return (
    <div
      style={{
        ...styles.innerHorizontalContainer,
        backgroundColor: gridBgColor,
        borderBottomRightRadius,
        borderBottomLeftRadius,
        ...containerStyle, // make sure this is also an object, not array
      }}>
      {scoreValue ? (
        <div style={styles.scoreContainer}>
          <TCText style={styles.score} value={scoreValue} />
        </div>
      ) : null}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  innerHorizontalContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  scoreContainer: {
    height: "34px",
    width: "59px",
    borderRadius: "12px",
    backgroundColor: Colors.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  score: {
    fontWeight: "500",
    fontSize: "11px",
    color: Colors.darkBrown,
  },
};
